import { WrappedDecimal } from "./WrappedDecimal";
export class WrappedLamport extends WrappedDecimal {
    isMax() {
        return this.getWrapped().isMax();
    }
    toU64() {
        return this.getAmount().toU64();
    }
    getAmount() {
        return this.getWrapped();
    }
}
//# sourceMappingURL=WrappedLamport.js.map